import React, { useState } from "react";
import { ClipboardList, Loader2, Play } from "lucide-react";
import ActiveCardShell from "../ActiveCardShell";
import { sleep, RunButton } from "./shared";

const fieldsFor = (m) => [
  ["Legal name", `${m.name} LLC`],
  ["DBA", m.name],
  ["Owner", m.owner],
  ["Owner phone", m.phone],
  ["Business address", m.addr],
  ["MCC", "5812 · Restaurants"],
  ["Monthly card volume", `$${m.volume.toLocaleString()}`],
  ["Average ticket", "$44.72"],
];

export default function IntakeCard({ merchant }) {
  const fields = fieldsFor(merchant);
  const [filled, setFilled] = useState(0);
  const [running, setRunning] = useState(false);

  const run = async () => {
    setRunning(true);
    setFilled(0);
    for (let i = 1; i <= fields.length; i += 1) { await sleep(380); setFilled(i); }
    setRunning(false);
  };

  const pct = Math.round((filled / fields.length) * 100);
  return (
    <ActiveCardShell id="T2500cr" kicker="ONBOARDING" title="Dynamic Intake" Icon={ClipboardList}
      actions={<RunButton tid="veroogle-t2500-run" running={running} onClick={run} Icon={running ? Loader2 : Play} label="Auto-fill application" />}>
      <div className="flex items-center justify-between mb-2 font-mono text-[10px] tracking-[0.18em] uppercase text-slate-400">
        <span>Merchant application · {merchant.name}</span>
        <span className="text-brand-cyan" data-testid="veroogle-t2500-progress">{pct}%</span>
      </div>
      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden mb-4">
        <div className="h-full bg-gradient-to-r from-brand-cyan to-brand-emerald transition-[width] duration-300" style={{ width: `${pct}%` }} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {fields.map(([label, value], i) => (
          <div key={label} data-testid={`veroogle-t2500-field-${i}`}
            className={`rounded-lg border px-3 py-2 transition-colors duration-300 ${i < filled ? "border-brand-cyan/40 bg-brand-cyan/5" : "border-white/10 bg-navy-950/50"}`}>
            <div className="font-mono text-[9px] tracking-[0.18em] uppercase text-slate-500">{label}</div>
            <div className={`text-sm mt-0.5 truncate ${i < filled ? "text-white" : "text-slate-600"}`}>{i < filled ? value : "—"}</div>
          </div>
        ))}
      </div>
    </ActiveCardShell>
  );
}
